<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-06-24 10:05:10
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-25 16:54:20
 * @FilePath: \new_typhoonmap\src\views\wacth.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myWatchBody">
    <div class="myMapBox" id="map"></div>
    <div class="leftContorllBox">
      <div class="contorBoxTitlebox">
        <div class="titleText">操作面板</div>
        <div class="titleText2">
          <!-- 风圈：
          <el-switch v-model="isSHowFengq" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
        </div>
      </div>
      <div class="controllerMainBox">
        <el-tabs v-model="activeName">
          <el-tab-pane label="台风" name="first">
            <div class="typhooonContrll">
              <div class="tyhoonTimeChooseBox">
                时间：
                <el-select
                  size="mini"
                  @change="typhoonTimeChange"
                  v-model="typhoonTime"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typhoonTimeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="tyListTableBox">
                <el-table
                  :data="typhoonListData"
                  @selection-change="handleSelectionChange"
                  style="width: 100%"
                  height="300"
                  ref="typhoonTable"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="tfid" label="台风编号"></el-table-column>
                  <el-table-column prop="name" label="台风名称"></el-table-column>
                  <el-table-column prop="enname" label="英文名称"></el-table-column>
                </el-table>
              </div>
              <div class="tyListTableBox">
                <div class="tableTitleBox">{{newChooseTyData.name}}（{{newChooseTyData.tfid}}）路径信息</div>
                <el-table :data="typhoonmoveList" style="width: 100%" height="300">
                  <el-table-column prop="newTime" label="时间" width="150"></el-table-column>
                  <el-table-column prop="speed" label="风速(m/s)"></el-table-column>
                  <el-table-column prop="strong" label="等级"></el-table-column>
                  <el-table-column prop="movedirection" label="移动方向"></el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="低压" name="second">低压</el-tab-pane>
          <el-tab-pane label="产品制作" name="third">产品制作</el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="legdBox">
      <div class="lendTitelBox">预报机构</div>
      <div class="lendTopbox">
        <el-checkbox-group v-model="chooseYvbaoData" @change="jigouchange">
          <div class="checkBigBox">
            <div class="checkBigBoxItem">
              <el-checkbox disabled  label="中国" key="中国">
                中国
                <span
                  style="color:#FF6450 !important;  font-weight: 900;font-weight: 900 !important;"
                >-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="中国香港" key="中国香港">
                中国香港
                <span
                  style="color:#FF66FF !important;  font-weight: 900;font-weight: 900 !important;"
                >-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="日本" key="日本">
                日本
                <span
                  style="color:#588E32 !important;  font-weight: 900;font-weight: 900 !important;"
                >-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="中国台湾" key="中国台湾">
                中国台湾
                <span
                  style="color:#FFA040 !important;  font-weight: 900;font-weight: 900 !important;"
                >-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="美国" key="美国">
                美国
                <span style="color:#FF00FF !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="韩国" key="韩国">
                韩国
                <span style="color:#669999 !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="欧洲" key="欧洲">
                欧洲
                <span style="color:#373591 !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="中大预报" key="中大预报">
                中大预报
                <span style="color:#FF0000 !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>

            <div class="checkBigBoxItem">
              <el-checkbox disabled label="中大AI" key="中大AI">
                中大AI
                <span style="color:#00FF00 !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled  label="中大测试" key="中大测试">
                中大测试
                <span style="color:#00FFFF !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="中大EC" key="中大EC">
                中大EC
                <span style="color:#FFFF00 !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
            <div class="checkBigBoxItem">
              <el-checkbox disabled label="中大GFS" key="中大GFS">
                中大GFS
                <span style="color:#AE83D6 !important;  font-weight: 900 !important;">-------</span>
              </el-checkbox>
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <div class="lendTitelBox">台风图例</div>
      <div class="typhoonLedBox">
        <div class="typhoonLedBoxItem">
          <div class="typhoonLedBoxItemletf" style="background-color:#008C14"></div>
          <div class="typhoonLedBoxItemright">热带低压</div>
        </div>
        <div class="typhoonLedBoxItem">
          <div class="typhoonLedBoxItemletf" style="background-color:#4299ED"></div>
          <div class="typhoonLedBoxItemright">热带风暴</div>
        </div>
        <div class="typhoonLedBoxItem">
          <div class="typhoonLedBoxItemletf" style="background-color:#FEFD32"></div>
          <div class="typhoonLedBoxItemright">热带强风暴</div>
        </div>
        <div class="typhoonLedBoxItem">
          <div class="typhoonLedBoxItemletf" style="background-color:#FF7518"></div>
          <div class="typhoonLedBoxItemright">台风</div>
        </div>
        <div class="typhoonLedBoxItem">
          <div class="typhoonLedBoxItemletf" style="background-color:#FF28FC"></div>
          <div class="typhoonLedBoxItemright">强台风</div>
        </div>
        <div class="typhoonLedBoxItem">
          <div class="typhoonLedBoxItemletf" style="background-color:#DB090B"></div>
          <div class="typhoonLedBoxItemright">超强台风</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../map/mapImport.js";
import moment from "moment";
export default {
  data() {
    return {
      mylastPrintdata:null,
      isSHowLast:false,
      // gettypoonName:"",
      tyhoopLayerData:[],
      map: null,
      isSHowFengq: false,
      typhoonPathLayer: null,
      typhoonPathLayer2: null,
      activeName: "first",
      typhoonTimeList: [],
      typhoonTime: "",
      typhoonListData: [],
      typhoonmoveList: [],
      newChooseTyData: {},
      typhoonPathData: [],
      pathDataList: {},
      chooseYvbaoData: [
        "中国",
        "中国香港",
        "日本",
        "中国台湾",
        "美国",
        "韩国",
        "欧洲",
        "中大预报",
        "中大AI",
        "中大测试",
        "中大EC",
        "中大GFS"
      ],
      chooseYvbaoData2: [
        "中国",
        "中国香港",
        "日本",
        "中国台湾",
        "美国",
        "韩国",
        "欧洲",
        "中大预报",
        "中大AI",
        "中大测试",
        "中大EC",
        "中大GFS"
      ]
    };
  },
  mounted() {
    this.map = new MapCreate();
    this.map.init("map");
    this.typhoonPathLayer2 = L.layerGroup().addTo(this.map.map);
    this.typhoonPathLayer = L.layerGroup().addTo(this.map.map);

    this.gettyphoonTimeList();
  },
  methods: {
    jigouchange(e){
      // console.log(e);
       this.tyhoopLayerData.map((eldata)=>{
        if(eldata.type=='yvbao')
        this.typhoonPathLayer.removeLayer(eldata.layer);
      })
      if(this.isSHowLast){
        
      this.getTyphoonLastPathData(this.mylastPrintdata)
      }else{
        console.log(888);
        console.log(this.typhoonListData);
        this.handleSelectionChange(this.typhoonListData)
      }
    },
    getTyphoonLastPathData(data) {
      this.mylastPrintdata =data
      this.isSHowLast = true
      // this.removeLayer
      // console.log(2222);
      // console.log(this.tyhoopLayerData);
      this.tyhoopLayerData.map((eldata)=>{
        if(eldata.typhoonName==data.name&&eldata.type=='yvbao')
        this.typhoonPathLayer.removeLayer(eldata.layer);
      })
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url}?interfaceId=getLastTypthoonForData&uuid=6ffd1a30-44f8-4298-a84e-a184sta2415etyp&thisid=${data.currentId}`
      }).then(res => {
        // console.log(res.data.dataList);
        this.pathDataList = {};
        let newdata = res.data.dataList;
        this.typhoonPathData = res.data.dataList;
        this.chooseYvbaoData2.map(item => {
          console.log(item);
          let mydata = newdata.filter(e => e.forecastAddress == item);
          // console.log(mydata);
          this.pathDataList[item] = mydata;
        });
        // console.log(this.pathDataList);
        // this.showpathTomap(this.pathDataList["中大测试"], "中大测试");
        this.chooseYvbaoData.map(item => {
          this.showpathTomap(this.pathDataList[item], item);
        });
      });
    },
    getTyphoonPathData(id) {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url}?interfaceId=getTyphoonForData&uuid=6ffd1a30-44f8-4298-a84e-a184sta2415etyp&thisid=${id}`
      }).then(res => {
        // console.log(res.data.dataList);
        this.pathDataList = {};
        let newdata = res.data.dataList;
        this.typhoonPathData = res.data.dataList;
        this.chooseYvbaoData2.map(item => {
          console.log(item);
          let mydata = newdata.filter(e => e.forecastAddress == item);
          // console.log(mydata);
          this.pathDataList[item] = mydata;
        });
        // console.log(this.pathDataList);
        // this.showpathTomap(this.pathDataList["中大测试"], "中大测试");
        this.chooseYvbaoData.map(item => {
          this.showpathTomap(this.pathDataList[item], item);
        });
      });
    },
    getTyphoonPointColor(speed) {
      var color;
      if (speed >= 51.0) color = "rgb(219,0,0)";
      else if (speed >= 41.5 && speed < 51.0) color = "rgb(255,0,255)";
      else if (speed >= 32.7 && speed < 41.5) color = "rgb(255,117,0)";
      else if (speed >= 24.5 && speed < 32.7) color = "rgb(255,255,0)";
      else if (speed >= 17.2 && speed < 24.5) color = "rgb(64,151,239)";
      else if (speed < 17.2) color = "rgb(0,141,0)";
      return color;
    },
    getTyphoonYubaoLine(value) {
      if (value == "中国") {
        return "#0000FF";
      } else if (value == "日本") {
        return "#588E32";
      } else if (value == "美国") {
        return "#FF00FF";
      } else if (value == "中国台湾") {
        return "#EE822F";
      } else if (value == "中国香港") {
        return "#F2BA02";
      } else if (value == "欧洲") {
        return "#4874CB";
      } else if (value == "韩国") {
        return "#843F0B";
      } else if (value == "中大预报") {
        return "#FF0000";
      } else if (value == "中大AI") {
        return "#00FF00";
      } else if (value == "中大测试") {
        return "#00FFFF";
      } else if (value == "中大EC") {
        return "#FFFF00";
      } else if (value == "中大GFS") {
        return "#AE83D6";
      } else {
        return "red";
      }
    },
    showpathTomap(data, name) {
      let t = this;

      //  console.log(data[0]);
      if (data[0] != undefined) {
        let startPrint = this.typhoonmoveList.find(e => {
          return e.currentId == data[0].currentId;
        });
        let printList  = [];
        if(startPrint!=undefined){
       printList  = [[startPrint.lat, startPrint.lng]];
        }else{
           printList  = [[this.typhoonmoveList[0].lat, this.typhoonmoveList[0].lng]];
        }
        
       
        
        data.map(item => {
          printList.push([item.lat, item.lng]);
        });
        let polyline = L.polyline(printList, {
          // radius:5,
          fillOpacity: 1,
          fillColor: "black",
          color: t.getTyphoonYubaoLine(name),
          weight: 2
        });
         this.tyhoopLayerData.push({
            name:name,
            layer:polyline,
          
            typhoonName:t.newChooseTyData.name,
            type:"yvbao"
          })
        this.typhoonPathLayer.addLayer(polyline);
        if (printList.length != 0) {
          this.map.map.fitBounds(polyline.getBounds());
        }

        data.map(item => {
          // printList.push([item.lat, item.lng]);
          let mymaker = L.circleMarker([item.lat, item.lng], {
            radius: 5,
            fillOpacity: 1,
            fillColor: t.getTyphoonPointColor(item.speed),
            color: "black",
            weight: 1
          });
          t.tyhoopLayerData.push({
            name:name,
            layer:mymaker,
            typhoonName:t.newChooseTyData.name,
            type:"yvbao"
          })
          t.typhoonPathLayer.addLayer(mymaker);
        });
      }
    },
    getTyphoonListData(time) {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url}?interfaceId=getHisTyphoonData&uuid=6ffd1a30-44f8-4298-a84e-a184sta2415etyp&starttime=${time}`
      }).then(res => {
        // console.log(res.data.dataList);
        this.typhoonListData = res.data.dataList;
        console.log(this.typhoonListData[0]);
        setTimeout(() => {
          this.$refs.typhoonTable.toggleRowSelection(this.typhoonListData[0]);
        }, 100);
      });
    },
    handleSelectionChange(el) {
      console.log(el);
      this.isSHowLast =false
      this.newChooseTyData = el.pop();
      console.log(121212);
      console.log(this.newChooseTyData);
      this.getTyphoonMoveListData(this.newChooseTyData.tfid);
   
      // this.gettypoonName = 
      console.log(4444);
      console.log(this.newChooseTyData);
    },
    getTyphoonMoveListData(id) {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${this.$url}?interfaceId=getTyphoonPathData&uuid=6ffd1a30-44f8-4298-a84e-a184sta2415etyp&element=${id}`
      }).then(res => {
        this.typhoonmoveList = [];
        // console.log(res.data.dataList);
        let newDatList = res.data.dataList;
        newDatList.sort((a, b) => b.time - a.time);
        console.log(newDatList);
        newDatList.map(item => {
          return (item.newTime = moment(item.time).format(
            "YYYY-MM-DD HH:mm:ss"
          ));
        });
        this.typhoonmoveList = newDatList;
        let printList = [];
        newDatList.map(item => {
          printList.push([item.lat, item.lng]);
        });
        let polyline = L.polyline(printList, {
          // radius:5,
          fillOpacity: 1,
          fillColor: "black",
          color: "#42A0FD",
          weight: 2
        });
        let t = this;
        this.typhoonPathLayer.addLayer(polyline);
        newDatList.map(item => {
          // printList.push([item.lat, item.lng]);
          let mymaker = L.circleMarker([item.lat, item.lng], {
            radius: 5,
            fillOpacity: 1,
            fillColor: "#42A0FD",
            color: "black",
            weight: 1
          });
          mymaker.on("click", () => {
            t.getTyphoonLastPathData(item);
          });
          mymaker.on("mouseover", () => {
            // console.log(2121212);
            L.popup()
              .setLatLng([item.lat, item.lng])
              .setContent(
                `
    <div>
    <p>台风名称:${item.name}</p>
    <p>到达时间:${item.time}</p>
    <p>经度:${item.lng}</p>
    <p>纬度:${item.lat}</p>
    <p>最大风速:${item.speed}m/s</p>
    <p>中心气压:${item.pressure}百帕</p>
    <p>移动速度:${item.movespeed}m/s</p>
    <p>移动方向:${item.movedirection}</p>
    <p>七级风圈半径:${item.radius7}</p>
    <p>十级风圈半径:${item.radius10}</p>
    </div>
    `
              )
              .openOn(this.map.map);
          });
          this.typhoonPathLayer.addLayer(mymaker);
        });
           this.getTyphoonPathData(this.newChooseTyData.tfid);
      });
    },
    typhoonTimeChange(e) {
      this.getTyphoonListData(e);
    },
    gettyphoonTimeList() {
      let mytime = new Date();

      // console.log( moment(mytime).year());
      let newYear = moment(mytime).year();

      for (let i = newYear; i >= 1949; i--) {
        this.typhoonTimeList.push({ value: i, lable: i });
      }
      this.getTyphoonListData(this.typhoonTimeList[0].value);
      this.typhoonTime = newYear;
    }
  }
};
</script>

<style>
.myWatchBody {
  height: 100vh;
  width: 100vw;
  background-color: aqua;
}
.myMapBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.leftContorllBox {
  width: 30vw;
  /* height: 50vh; */
  background-color: white;
  position: absolute;
  right: 30px;
  top: 100px;
  border-radius: 10px;
  z-index: 2;
  padding: 0px 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.contorBoxTitlebox {
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(146, 146, 146);
}
.titleText {
  height: 50px;
  line-height: 50px;
  /* width: 300px; */
  /* text-align: center; */
  /* padding-left: 15px; */
}
.titleText2 {
  height: 50px;
  display: flex;
  align-items: center;
}
.controllerMainBox {
  /* height: 400px; */
  width: 100%;
  margin-top: 20px;
  /* background-color: red; */
}
.typhooonContrll {
  /* height: 500px; */
  width: 100%;
  /* background-color: red; */
}
.tyhoonTimeChooseBox {
  height: 50px;
  width: 100%;
  /* background-color: aqua; */
  display: flex;
  justify-content: center;
}
.tyListTableBox {
  height: 300px;
  width: 100%;
  /* background-color: aqua; */
}
.tableTitleBox {
  text-align: center;
}
.legdBox {
  width: 250px;
  height: 300px;
  background-color: #6ea3e2;
  position: absolute;
  bottom: 25px;
  left: 25px;
  z-index: 2;
  border-radius: 10px;
  padding: 5px;
}
.lendTitelBox {
  height: 30px;
  width: 100%;
  /* background-color: aqua; */
  /* text-align: center; */
  line-height: 30px;
  color: white;
}
.lendTopbox {
  width: 100%;
  height: 150px;
  /* padding: 10px; */

  /* background-color: red; */
}
.checkBigBox {
  padding: 0px 10px;
  width: 100%;
  height: 150px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.checkBigBoxItem {
  width: 40%;
  height: 20px;
  display: flex;
  align-items: center;
}
.el-checkbox {
  color: black !important;
}
.el-checkbox__label {
  font-size: 10px !important;
}
.typhoonLedBox {
  height: 80px;
  width: 100%;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
}
.typhoonLedBoxItem {
  width: 45%;
  height: 25px;
  /* background-color: red; */
  display: flex;
  align-items: center;
  font-size: 12px;
  /* justify-content: space-between; */
}
.typhoonLedBoxItemletf {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 1px solid black;
  /* background-color: #6ea3e2; */
}
.typhoonLedBoxItemright {
  margin-left: 15px;
}
</style>